import {createAction} from 'Shared/utilities/actionCreator';
import {EmptyUser, User} from 'Users/models/User/User';

export enum UserEntryEditActionType {
  CHANGE_USER = 'userEntryEdit/CHANGE_USER',
}

export const changeUser = (user: User) => createAction(UserEntryEditActionType.CHANGE_USER, {user});

export type UserEntryEditState = {
  user: User;
};

const DEFAULT_STATE = {
  user: EmptyUser,
};

export type UserEntryEditAction = ReturnType<typeof changeUser>;

export default (state: UserEntryEditState = DEFAULT_STATE, action: UserEntryEditAction): UserEntryEditState => {
  switch (action.type) {
    case UserEntryEditActionType.CHANGE_USER:
      return {
        ...state,
        user: action.payload.user,
      };
    default:
      return state;
  }
};
